<script setup lang='ts'>
import { useShareSetting } from '@/composables/useShare'

const props = withDefaults(defineProps<{
  offset?: number
  top?: string
}>(), {
  offset: 160,
})

const {
  weiboShareUrl,
  qzoneShareUrl,
  weixinQrcode,
} = useShareSetting()
</script>

<template>
  <NAffix :top="props.offset" class="-translate-x-[calc(100%+1rem)]">
    <div class="bg-white p-sm rounded-1.5 text-3 flex flex-col items-center max-fixed">
      <NPopover v-if="weixinQrcode" trigger="hover">
        <template #trigger>
          <div class="flex items-center cursor-pointer">
            <i class="i-custom-weixin?bg" />
            <div class="ml-2">
              微信好友
            </div>
          </div>
        </template>
        <div class="">
          <img class="w-25 h-25 m-auto" :src="weixinQrcode">
          <div class="text-3 text-slate-4">
            微信扫码分享给好友
          </div>
        </div>
      </NPopover>
      <a v-if="qzoneShareUrl" class="flex items-center cursor-pointer mt-2" :href="qzoneShareUrl" target="_blank">
        <i class="i-custom-qq?bg" />
        <div class="ml-2">QQ好友</div>
      </a>
      <a v-if="weiboShareUrl" class="flex items-center cursor-pointer mt-2" :href="weiboShareUrl" target="_blank">
        <i class="i-custom-weibo?bg" />
        <div class="ml-2">新浪微博</div>
      </a>
      <a v-if="qzoneShareUrl" class="flex items-center cursor-pointer mt-2" :href="qzoneShareUrl" target="_blank">
        <i class="i-custom-qzone?bg" />
        <div class="ml-2">QQ空间</div>
      </a>
    </div>
  </NAffix>
</template>

<style lang='scss' scoped>

</style>
